import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-assig-link-to-domain',
  templateUrl: './assig-link-to-domain.component.html',
  styleUrls: ['./assig-link-to-domain.component.css']
})
export class AssigLinkToDomainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
